import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=c8256d44&scoped=true&"
import script from "./EditGroup.vue?vue&type=script&lang=js&"
export * from "./EditGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditGroup.vue?vue&type=style&index=0&id=c8256d44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8256d44",
  null
  
)

export default component.exports